import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { removeProductDemoDomainQueries } from '~modules/product-demo/product-demo-query-cache';
import { getProductDemoRuntimeUserId } from '~modules/product-demo/product-demo-runtime';
import { productDemoStorage } from '~modules/product-demo/product-demo-storage';

import { ROUTES } from '~app/router/routes';

export const useExitProductDemo = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCallback(() => {
    productDemoStorage.disable(getProductDemoRuntimeUserId());
    removeProductDemoDomainQueries(queryClient);
    navigate(ROUTES.ONBOARDING);
  }, [navigate, queryClient]);
};
